import { makeRoute } from "@/lib/makeRoute";
export const Route = makeRoute("/en/faq", "en", "faq");
